/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/no-danger */
import { Tooltip } from 'antd';
import * as DOMPurify from 'dompurify';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { Loading } from 'components/atoms/loading';
import { Popover } from 'components/atoms/popover';
import { RichTextEditor } from 'components/atoms/rich-text-editor/rich-text-editor';
import ckeStyles from 'components/organisms/templates/commons/cke.module.css';

interface TaskNameProps {
  taskName: string;
  dataCy?: string;
  className?: string;
  style?: React.CSSProperties;
}

interface PhaseNameProps {
  phaseName: string;
}

export const TaskName = ({
  taskName,
  dataCy,
  className,
  style,
}: TaskNameProps) => {
  return (
    <Tooltip
      destroyTooltipOnHide
      placement="topLeft"
      title={
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(taskName),
          }}
        />
      }
    >
      <div
        data-cy={dataCy}
        style={style}
        className={`project-template-task ${className ?? ''}`}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(taskName),
        }}
      />
    </Tooltip>
  );
};

export const PhaseName = ({ phaseName }: PhaseNameProps) => {
  const content = (
    <div
      className="project-template-task"
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(phaseName),
      }}
    />
  );

  return (
    <Tooltip placement="topLeft" title={content} destroyTooltipOnHide>
      {content}
    </Tooltip>
  );
};

export const TemplateImportNameField = ({ name }: { name: string }) => {
  return (
    <RichTextEditor
      className={`${ckeStyles['template-title-input']}  ${ckeStyles['template-list-view']} ${ckeStyles['template-import-name-field']}`}
      data={name}
      readonly
      allowConditionalVariables
      disallowNewLine
    />
  );
};

const EditorContainer = styled.div`
  max-width: 500px;
  padding: var(--spacing-03);
  min-height: 14px;
  min-width: 14px;
`;

type TemplateTaskNameProps = TaskNameProps & {
  taskNameInTooltip: string;
};

export const TemplateTaskName = ({
  taskName,
  dataCy,
  className,
  style,
  taskNameInTooltip,
}: TemplateTaskNameProps) => {
  const [rteInitialized, setRteInitialized] = useState(false);
  const [initailizeRte, setInitailizeRte] = useState(false);
  const onPopoverVisibilityChange = useCallback((visible) => {
    if (visible) {
      setTimeout(() => setInitailizeRte(true), 500);
    } else {
      setTimeout(() => {
        setInitailizeRte(false);
        setRteInitialized(false);
      }, 500);
    }
  }, []);
  const onRTEInit = useCallback(() => {
    setRteInitialized(true);
  }, []);

  return (
    <Popover
      getPopupContainer={() => document.body}
      placement="bottomLeft"
      trigger={['hover']}
      onVisibleChange={onPopoverVisibilityChange}
      content={
        <EditorContainer>
          {!rteInitialized ? <Loading size="small" /> : null}
          {initailizeRte ? (
            <RichTextEditor
              className={`${ckeStyles['template-title-input']} ${ckeStyles['template-task-name-in-tooltip']}`}
              data={taskNameInTooltip ?? ''}
              readonly
              allowConditionalVariables
              disallowNewLine
              noToolbar
              onInit={onRTEInit}
            />
          ) : null}
        </EditorContainer>
      }
    >
      <div
        data-cy={dataCy}
        style={style}
        className={`project-template-task ${className ?? ''}`}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(taskName),
        }}
      />
    </Popover>
  );
};

export const ShiftDaysNameField = TemplateImportNameField;
